import { useContext } from "react";
import { ThemeContext } from "../../components/ThemeContext";
import { ContactForm } from "../../components/ContactForm";
import { useTranslation } from "react-i18next";


export const Contact = () => {
    const [theme] = useContext(ThemeContext);
    const { t } = useTranslation();
    return (
    
        <div className={`contact py-4 sm:py-10 ${theme}`}> 
            <div className="container mx-auto">
                <div className="grid sm:grid-cols-2 gap-4">
                    <div className="">
                        <h1 className="text-4xl md:text-6xl font-bold uppercase"> {t('contact.title')} </h1>
                        <p className="mt-2">
                        {t('contact.description')}
                        </p>
                        <ul className="contact-info mt-4 text-xl">
                            <li><a href="tel:+421908000000">+421 908 000 000</a></li>
                            <li><a href="mailto:info@veridian.com">info@veridian.com</a></li>
                        </ul>
                        <ContactForm />
                        
                    </div>
                    <div className="contact-map">
                        <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d59039.43314482856!2d20.080709587891935!3d49.15883143832772!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x473e20c4feca0ce5%3A0xd04954eeb21e67d1!2zR2VybGFjaG92c2vDvSDFoXTDrXQ!5e0!3m2!1ssk!2ssk!4v1742215638361!5m2!1ssk!2ssk" 
                        className="w-full h-[450px]"
                        loading="lazy"
                        allowFullScreen={true}
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Google Maps Location"
                    ></iframe>
                    </div>
                </div>
            </div>
       </div>
    )
};



  
  